import { apiClient } from "lib/apiClient";

export const archiveMarketAreas = async (ids: string[]): Promise<void> => {
  await apiClient.post("/market-areas/archive", ids);
};
